// ** Routes Imports
import { getHomeRouteForLoggedInUser } from '@utils';
import { getUserData } from '../../auth/utils';
import ComingSoon from '../../views/misc/ComingSoon';
import PagesRoutes from './Pages';
import AdminRoutes from './admin';
import ownershipChangeRoutes from './ownershipChange/ownershipChange';
import enviromentalTagRoutes from './enviromentalTag/enviromentalTag';
import dgtReportRoutes from './dgtReport/dgtReport';
import UserRoutes from './contacts/Contacts';
import ContactsRoutes from './contacts/Contacts';

// ** Document title
const TemplateTitle = '%s - Tuintcar';

// ** Default Route
const data = getUserData();
const main = data ? data.ability.find((reg) => reg.action === 'read') : '';
const DefaultRoute = main ? getHomeRouteForLoggedInUser() : '';

// ** Merge Routes
const Routes = [
  ...PagesRoutes,
  ...AdminRoutes,
  ...ownershipChangeRoutes,
  ...enviromentalTagRoutes,
  ...dgtReportRoutes,
  ...UserRoutes,
  ...ContactsRoutes,
  {
    path: '/commingSoon',
    exact: true,
    layout: 'VerticalLayout',
    component: () => ComingSoon(),
  },
];

export { DefaultRoute, Routes, TemplateTitle };
